<template>
  <CommunicationsManager
    ref="communicationsManager"
    :settings-path="settingsPath"
    :change-history-path="changeHistoryPath"
    :subpage="true"
  />
</template>

<script setup lang="ts">
import { ref } from "vue";

import CommunicationsManager from "@/Communications/CommunicationsManager.vue";

defineProps({
  settingsPath: {
    type: String,
    required: true
  },
  changeHistoryPath: {
    type: String,
    required: true
  }
});

const communicationsManager = ref(null);

function settingsChanged() {
  return communicationsManager.value.settingsChanged();
}

defineExpose({ settingsChanged });
</script>

<style lang="scss" scoped></style>
